import {
  getBreakpoints,
  getDefaultContext,
  getDefaultSize,
  LayoutResponsive,
  WindowBreakpoints,
  WindowSize,
} from '@dustin-web/microsite-config'
import React, { createContext, useRef, useState } from 'react'
import { useSiteContext } from '../use-site-context'
import useResizeObserver from 'use-resize-observer'

export const LayoutResponsiveContext = createContext<LayoutResponsive>(getDefaultContext())

export const LayoutResponsiveProvider = ({ children }: { children?: React.ReactNode }) => {
  const { isMobile } = useSiteContext()
  const [isSmallScreen, setIsSmallScreen] = useState(isMobile)
  const [windowSize, setWindowSize] = useState<WindowSize>(getDefaultSize(isMobile))
  const [breakpoints, setBreakpoints] = useState<WindowBreakpoints>(
    getBreakpoints(getDefaultSize(isMobile))
  )

  const elementRef = useRef<HTMLElement>(null)

  React.useEffect(() => {
    elementRef.current = document.body
  }, [])

  useResizeObserver({
    ref: elementRef as React.RefObject<HTMLElement>,
    onResize: ({ width, height }) => {
      if (!width || !height) {
        return
      }

      const size = { width, height }
      const bp = getBreakpoints(size)

      setWindowSize(size)
      setBreakpoints(bp)
      setIsSmallScreen(!bp.min.LG)
    },
  })

  const state = {
    windowSize,
    breakpoints,
    isSmallScreen,
  }

  return (
    <LayoutResponsiveContext.Provider value={state}>{children}</LayoutResponsiveContext.Provider>
  )
}
